// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/core-js/modules/es6.number.is-nan.js
// module id = 317
// module chunks = 0